import { createFileRoute } from "@tanstack/react-router";
import { Rechner } from "../features/shell/Rechner";

export const Route = createFileRoute("/rechner")({
  component: Rechner,
});
